import { Avatar } from '@change-corgi/design-system-legacy/components/media';

type Props = {
	displayName: string;
	photo: {
		userMedium: {
			processing: boolean;
			url: string;
		};
	} | null;
};

export function DmAvatar({ displayName, photo }: Props): React.JSX.Element {
	const photoUrl = photo?.userMedium.processing ? undefined : photo?.userMedium.url;

	return <Avatar variant="subtle" src={photoUrl} mr={10} size={50} alt={`avatar for ${displayName}`} loading="lazy" />;
}
